// import {
//     Avatar,
//     Box,
//     Button,
//     Grid,
//     List,
//     ListItem,
//     MenuItem,
//     OutlinedInput,
//     Paper,
//     Stack,
//     Tab,
//     Tabs,
//     Typography,
//   } from "@mui/material";
//   import React, { useEffect, useState } from "react";
//   import styles from "../../styles/pages/myaccount.module.scss";
//   import styles1 from "../../styles/components/partnerSubmissionFeeModal.module.scss";
//   import assest from "../../json/assest";
//   import Select, { SelectChangeEvent } from "@mui/material/Select";
//   import { parseCookies } from "nookies";
//   import validationText from "../../json/messages/validationText";
//   import * as yup from "yup";
//   import { yupResolver } from "@hookform/resolvers/yup";
//   import { Controller, useForm } from "react-hook-form";
//   import { useMutation, useQuery, useQueryClient } from "react-query";
//   import { ProfileUpdateMutation } from "../../api/functions/user.api";
//   import { any, array } from "prop-types";
//   import { useAppSelector } from "../../hooks/useAppSelector";
// //   import { logout, setLoginData } from "../../reduxtoolkit/slices/userSlice";
//   import useNotiStack from "../../hooks/useNotistack";
//   import { phoneRegExp } from "../../config/regExp";
//   import { trimStartAndEnd } from "../../lib/functions/_helpers.lib";
//   import {Link} from "react-router-dom";
//   import EditBlueIcon from "../../ui/Icons/EditBlueIcon";
//   import TabBackIcon from "../../ui/Icons/TabBackIcon";
//   import TabSaveIcon from "../../ui/Icons/TabSaveIcon";
//   import PerfectScrollbar from "react-perfect-scrollbar";
//   import "react-perfect-scrollbar/dist/css/styles.css";
//   import { EditorUserDeatilsutation } from "../../api/functions/editor.api";
//   import { CopyWUserDeatilsutation } from "../../api/functions/copywriters.api";
// import { useNavigate } from "react-router";

//   const countryData = [
//     { name: "Afghanistan", code: "AF" },
//     { name: "Åland Islands", code: "AX" },
//     { name: "Albania", code: "AL" },
//     { name: "Algeria", code: "DZ" },
//     { name: "American Samoa", code: "AS" },
//     { name: "AndorrA", code: "AD" },
//     { name: "Angola", code: "AO" },
//     { name: "Anguilla", code: "AI" },
//     { name: "Antarctica", code: "AQ" },
//     { name: "Antigua and Barbuda", code: "AG" },
//     { name: "Argentina", code: "AR" },
//     { name: "Armenia", code: "AM" },
//     { name: "Aruba", code: "AW" },
//     { name: "Australia", code: "AU" },
//     { name: "Austria", code: "AT" },
//     { name: "Azerbaijan", code: "AZ" },
//     { name: "Bahamas", code: "BS" },
//     { name: "Bahrain", code: "BH" },
//     { name: "Bangladesh", code: "BD" },
//     { name: "Barbados", code: "BB" },
//     { name: "Belarus", code: "BY" },
//     { name: "Belgium", code: "BE" },
//     { name: "Belize", code: "BZ" },
//     { name: "Benin", code: "BJ" },
//     { name: "Bermuda", code: "BM" },
//     { name: "Bhutan", code: "BT" },
//     { name: "Bolivia", code: "BO" },
//     { name: "Bosnia and Herzegovina", code: "BA" },
//     { name: "Botswana", code: "BW" },
//     { name: "Bouvet Island", code: "BV" },
//     { name: "Brazil", code: "BR" },
//     { name: "British Indian Ocean Territory", code: "IO" },
//     { name: "Brunei Darussalam", code: "BN" },
//     { name: "Bulgaria", code: "BG" },
//     { name: "Burkina Faso", code: "BF" },
//     { name: "Burundi", code: "BI" },
//     { name: "Cambodia", code: "KH" },
//     { name: "Cameroon", code: "CM" },
//     { name: "Canada", code: "CA" },
//     { name: "Cape Verde", code: "CV" },
//     { name: "Cayman Islands", code: "KY" },
//     { name: "Central African Republic", code: "CF" },
//     { name: "Chad", code: "TD" },
//     { name: "Chile", code: "CL" },
//     { name: "China", code: "CN" },
//     { name: "Christmas Island", code: "CX" },
//     { name: "Cocos (Keeling) Islands", code: "CC" },
//     { name: "Colombia", code: "CO" },
//     { name: "Comoros", code: "KM" },
//     { name: "Congo", code: "CG" },
//     { name: "Congo, The Democratic Republic of the", code: "CD" },
//     { name: "Cook Islands", code: "CK" },
//     { name: "Costa Rica", code: "CR" },
//     { name: "Cote D'Ivoire", code: "CI" },
//     { name: "Croatia", code: "HR" },
//     { name: "Cuba", code: "CU" },
//     { name: "Cyprus", code: "CY" },
//     { name: "Czech Republic", code: "CZ" },
//     { name: "Denmark", code: "DK" },
//     { name: "Djibouti", code: "DJ" },
//     { name: "Dominica", code: "DM" },
//     { name: "Dominican Republic", code: "DO" },
//     { name: "Ecuador", code: "EC" },
//     { name: "Egypt", code: "EG" },
//     { name: "El Salvador", code: "SV" },
//     { name: "Equatorial Guinea", code: "GQ" },
//     { name: "Eritrea", code: "ER" },
//     { name: "Estonia", code: "EE" },
//     { name: "Ethiopia", code: "ET" },
//     { name: "Falkland Islands (Malvinas)", code: "FK" },
//     { name: "Faroe Islands", code: "FO" },
//     { name: "Fiji", code: "FJ" },
//     { name: "Finland", code: "FI" },
//     { name: "France", code: "FR" },
//     { name: "French Guiana", code: "GF" },
//     { name: "French Polynesia", code: "PF" },
//     { name: "French Southern Territories", code: "TF" },
//     { name: "Gabon", code: "GA" },
//     { name: "Gambia", code: "GM" },
//     { name: "Georgia", code: "GE" },
//     { name: "Germany", code: "DE" },
//     { name: "Ghana", code: "GH" },
//     { name: "Gibraltar", code: "GI" },
//     { name: "Greece", code: "GR" },
//     { name: "Greenland", code: "GL" },
//     { name: "Grenada", code: "GD" },
//     { name: "Guadeloupe", code: "GP" },
//     { name: "Guam", code: "GU" },
//     { name: "Guatemala", code: "GT" },
//     { name: "Guernsey", code: "GG" },
//     { name: "Guinea", code: "GN" },
//     { name: "Guinea-Bissau", code: "GW" },
//     { name: "Guyana", code: "GY" },
//     { name: "Haiti", code: "HT" },
//     { name: "Heard Island and Mcdonald Islands", code: "HM" },
//     { name: "Holy See (Vatican City State)", code: "VA" },
//     { name: "Honduras", code: "HN" },
//     { name: "Hong Kong", code: "HK" },
//     { name: "Hungary", code: "HU" },
//     { name: "Iceland", code: "IS" },
//     { name: "India", code: "IN" },
//     { name: "Indonesia", code: "ID" },
//     { name: "Iran, Islamic Republic Of", code: "IR" },
//     { name: "Iraq", code: "IQ" },
//     { name: "Ireland", code: "IE" },
//     { name: "Isle of Man", code: "IM" },
//     { name: "Israel", code: "IL" },
//     { name: "Italy", code: "IT" },
//     { name: "Jamaica", code: "JM" },
//     { name: "Japan", code: "JP" },
//     { name: "Jersey", code: "JE" },
//     { name: "Jordan", code: "JO" },
//     { name: "Kazakhstan", code: "KZ" },
//     { name: "Kenya", code: "KE" },
//     { name: "Kiribati", code: "KI" },
//     { name: "Korea, Democratic People'S Republic of", code: "KP" },
//     { name: "Korea, Republic of", code: "KR" },
//     { name: "Kuwait", code: "KW" },
//     { name: "Kyrgyzstan", code: "KG" },
//     { name: "Lao People'S Democratic Republic", code: "LA" },
//     { name: "Latvia", code: "LV" },
//     { name: "Lebanon", code: "LB" },
//     { name: "Lesotho", code: "LS" },
//     { name: "Liberia", code: "LR" },
//     { name: "Libyan Arab Jamahiriya", code: "LY" },
//     { name: "Liechtenstein", code: "LI" },
//     { name: "Lithuania", code: "LT" },
//     { name: "Luxembourg", code: "LU" },
//     { name: "Macao", code: "MO" },
//     { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
//     { name: "Madagascar", code: "MG" },
//     { name: "Malawi", code: "MW" },
//     { name: "Malaysia", code: "MY" },
//     { name: "Maldives", code: "MV" },
//     { name: "Mali", code: "ML" },
//     { name: "Malta", code: "MT" },
//     { name: "Marshall Islands", code: "MH" },
//     { name: "Martinique", code: "MQ" },
//     { name: "Mauritania", code: "MR" },
//     { name: "Mauritius", code: "MU" },
//     { name: "Mayotte", code: "YT" },
//     { name: "Mexico", code: "MX" },
//     { name: "Micronesia, Federated States of", code: "FM" },
//     { name: "Moldova, Republic of", code: "MD" },
//     { name: "Monaco", code: "MC" },
//     { name: "Mongolia", code: "MN" },
//     { name: "Montserrat", code: "MS" },
//     { name: "Morocco", code: "MA" },
//     { name: "Mozambique", code: "MZ" },
//     { name: "Myanmar", code: "MM" },
//     { name: "Namibia", code: "NA" },
//     { name: "Nauru", code: "NR" },
//     { name: "Nepal", code: "NP" },
//     { name: "Netherlands", code: "NL" },
//     { name: "Netherlands Antilles", code: "AN" },
//     { name: "New Caledonia", code: "NC" },
//     { name: "New Zealand", code: "NZ" },
//     { name: "Nicaragua", code: "NI" },
//     { name: "Niger", code: "NE" },
//     { name: "Nigeria", code: "NG" },
//     { name: "Niue", code: "NU" },
//     { name: "Norfolk Island", code: "NF" },
//     { name: "Northern Mariana Islands", code: "MP" },
//     { name: "Norway", code: "NO" },
//     { name: "Oman", code: "OM" },
//     { name: "Pakistan", code: "PK" },
//     { name: "Palau", code: "PW" },
//     { name: "Palestinian Territory, Occupied", code: "PS" },
//     { name: "Panama", code: "PA" },
//     { name: "Papua New Guinea", code: "PG" },
//     { name: "Paraguay", code: "PY" },
//     { name: "Peru", code: "PE" },
//     { name: "Philippines", code: "PH" },
//     { name: "Pitcairn", code: "PN" },
//     { name: "Poland", code: "PL" },
//     { name: "Portugal", code: "PT" },
//     { name: "Puerto Rico", code: "PR" },
//     { name: "Qatar", code: "QA" },
//     { name: "Reunion", code: "RE" },
//     { name: "Romania", code: "RO" },
//     { name: "Russian Federation", code: "RU" },
//     { name: "RWANDA", code: "RW" },
//     { name: "Saint Helena", code: "SH" },
//     { name: "Saint Kitts and Nevis", code: "KN" },
//     { name: "Saint Lucia", code: "LC" },
//     { name: "Saint Pierre and Miquelon", code: "PM" },
//     { name: "Saint Vincent and the Grenadines", code: "VC" },
//     { name: "Samoa", code: "WS" },
//     { name: "San Marino", code: "SM" },
//     { name: "Sao Tome and Principe", code: "ST" },
//     { name: "Saudi Arabia", code: "SA" },
//     { name: "Senegal", code: "SN" },
//     { name: "Serbia and Montenegro", code: "CS" },
//     { name: "Seychelles", code: "SC" },
//     { name: "Sierra Leone", code: "SL" },
//     { name: "Singapore", code: "SG" },
//     { name: "Slovakia", code: "SK" },
//     { name: "Slovenia", code: "SI" },
//     { name: "Solomon Islands", code: "SB" },
//     { name: "Somalia", code: "SO" },
//     { name: "South Africa", code: "ZA" },
//     { name: "South Georgia and the South Sandwich Islands", code: "GS" },
//     { name: "Spain", code: "ES" },
//     { name: "Sri Lanka", code: "LK" },
//     { name: "Sudan", code: "SD" },
//     { name: "Suriname", code: "SR" },
//     { name: "Svalbard and Jan Mayen", code: "SJ" },
//     { name: "Swaziland", code: "SZ" },
//     { name: "Sweden", code: "SE" },
//     { name: "Switzerland", code: "CH" },
//     { name: "Syrian Arab Republic", code: "SY" },
//     { name: "Taiwan, Province of China", code: "TW" },
//     { name: "Tajikistan", code: "TJ" },
//     { name: "Tanzania, United Republic of", code: "TZ" },
//     { name: "Thailand", code: "TH" },
//     { name: "Timor-Leste", code: "TL" },
//     { name: "Togo", code: "TG" },
//     { name: "Tokelau", code: "TK" },
//     { name: "Tonga", code: "TO" },
//     { name: "Trinidad and Tobago", code: "TT" },
//     { name: "Tunisia", code: "TN" },
//     { name: "Turkey", code: "TR" },
//     { name: "Turkmenistan", code: "TM" },
//     { name: "Turks and Caicos Islands", code: "TC" },
//     { name: "Tuvalu", code: "TV" },
//     { name: "Uganda", code: "UG" },
//     { name: "Ukraine", code: "UA" },
//     { name: "United Arab Emirates", code: "AE" },
//     { name: "United Kingdom", code: "GB" },
//     { name: "United States", code: "US" },
//     { name: "United States Minor Outlying Islands", code: "UM" },
//     { name: "Uruguay", code: "UY" },
//     { name: "Uzbekistan", code: "UZ" },
//     { name: "Vanuatu", code: "VU" },
//     { name: "Venezuela", code: "VE" },
//     { name: "Viet Nam", code: "VN" },
//     { name: "Virgin Islands, British", code: "VG" },
//     { name: "Virgin Islands, U.S.", code: "VI" },
//     { name: "Wallis and Futuna", code: "WF" },
//     { name: "Western Sahara", code: "EH" },
//     { name: "Yemen", code: "YE" },
//     { name: "Zambia", code: "ZM" },
//     { name: "Zimbabwe", code: "ZW" },
//   ];

// //   interface forgotProps {
// //     // forgotText: 'myaccount' | 'editor' | 'copywriter' | 'for_partners';
// //     forgotText:
// //     | "myaccount"
// //     | "editor"
// //     | "copywriter"
// //     | "for_partners"
// //     | "for_QC"
// //     | "for_manager";
// //     accountSubmission: boolean;

// //     userdata: any;
// //   }

// //   interface TabPanelProps {
// //     children?: React.ReactNode;
// //     index: number;
// //     value: number;
// //   }

//   //=== TYPES ====
// //   interface MyAccInput {
// //     name: string;
// //     last_name: string;
// //     address: string;
// //     city: string;
// //     zip: string;
// //     state: string;
// //     phone: string;
// //     avatar: string;
// //     country: string;
// //   }

//   // schema

//   const schema = yup.object().shape({
//     name: yup
//       .string()
//       .trim()
//       .required()
//       .label("First Name")
//       .max(256)
//       .transform(trimStartAndEnd),

//     last_name: yup
//       .string()
//       .trim()
//       .required()
//       .label("Last Name")
//       .max(256)
//       .transform(trimStartAndEnd),

//     address: yup.string().max(32),
//     city: yup.string().max(32),

//     zip: yup.string().max(7),

//     phone: yup
//       .string()
//       .required()
//       .matches(phoneRegExp, "Phone number is not valid")
//       .label("Phone number"),

//     state: yup.string().max(32),
//   });
//   function TabPanel(props) {
//     const { children, value, index, ...other } = props;

//     return (
//       <div
//         role="tabpanel"
//         hidden={value !== index}
//         id={`simple-tabpanel-${index}`}
//         aria-labelledby={`simple-tab-${index}`}
//         {...other}
//           >
//         {value === index && <Box>{children}</Box>}
//       </div>
//     );
//   }

//   function a11yProps(index) {
//     return {
//       id: `simple-tab-${index}`,
//       "aria-controls": `simple-tabpanel-${index}`,
//     };
//   }

//   const CopyWritesUserCreateTab = (props) => {

//     const cookies = parseCookies();
//     const userdeatails = JSON?.parse(cookies?.userdetails || "{}");

//     const { userData } = useAppSelector((s) => s.userSlice);
//     const { data: CopywritersUserdetails } = useQuery(

//       ["userdeatils", props?.userdata.id],
//       async () => {
//         return CopyWUserDeatilsutation(props?.userdata.id);
//       }
//     );

//     const [value, setValue] = React.useState(0);
//     const [age, setAge] = React.useState("");
//     const [dis, setDis] = useState(true);
//     const [dis1, setDis1] = useState(true);
//     const [dis2, setDis2] = useState(true);
//     const handleChange = (event, newValue) => {
//       setValue(newValue);
//     };

//     const {
//       handleSubmit,
//       control,
//       register,

//       reset,
//       formState: { errors },
//       formState,
//     } = useForm({
//       resolver: yupResolver(schema),
//       values: {
//         name: CopywritersUserdetails?.name,
//         last_name: CopywritersUserdetails?.last_name,
//         address: CopywritersUserdetails?.address,
//         city: CopywritersUserdetails?.city,
//         zip: CopywritersUserdetails?.zip,
//         state: CopywritersUserdetails?.state,
//         phone: CopywritersUserdetails?.phone,
//         avatar: CopywritersUserdetails?.avatar,
//         country: CopywritersUserdetails?.country,
//       },
//     });
//     // const onSubmit = (data: MyAccInput) => console.warn(data);
//     const [Country, setCountry] = useState("");

//     const handleChange2 = (event) => {
//       setCountry(event.target.value);
//     };
//     const handleopenD = () => {
//       setDis(false);
//     };
//     const handleopenD1 = () => {
//       setDis1(false);
//     };
//     const handleopenD2 = () => {
//       setDis2(false);
//     };

//     const handleopenDD = () => {
//       setDis(true);
//     };
//     const handleopenDD1 = () => {
//       setDis1(true);boolean
//     };
//     const handleopenDD2 = () => {
//       setDis2(true);
//     };

//     const { mutateAsync: ProfileUpdateMutationAA } = useMutation({
//       mutationFn: ProfileUpdateMutation,
//     });
//     const { toastSuccess, toastError } = useNotiStack();
//     const queryClient = useQueryClient();
//     7;
//     const [profileImage, setProfileImage] = useState<any>(null);
//     console.warn(
//       "🚀 ~ file: UserCreateTab.tsx:447 ~ UserCreateTab ~ profileImage:",
//       profileImage
//     );

//     const removeprofileImage = () => {
//       setProfileImage(null);
//     };

//     function handleProfileImage1(e) {
//       if (
//         e.target.files[0]?.type === "image/jpeg" ||
//         e.target.files[0]?.type === "image/png" ||
//         e.target.files[0]?.type === "image/jpg"
//       ) {
//         if (e.target.files[0]?.size <= 10000000) {
//           setProfileImage(e.target.files[0]);
//         } else {
//           toastError("Please upload image of proper size.");
//         }
//       } else {
//         toastError("Please upload image of proper format.");
//       }
//     }

//     const onSubmit = (data) => {
//       const formData = new FormData();
//       {
//         profileImage === null ? "" : formData.append("avatar", profileImage);
//       }
//       formData.append("name", data?.name);
//       formData.append("last_name", data?.last_name);
//       formData.append("user_id", props?.userdata?.id);
//       formData.append("email", CopywritersUserdetails?.email);
//       formData.append("address", data?.address);
//       formData.append("city", data?.city);
//       formData.append("zip", data?.zip);
//       formData.append("phone", data?.phone);
//       formData.append("state", data?.state);
//       formData.append("country", Country);

//       ProfileUpdateMutationAA(formData).then((response) => {
//         if (response.message === "User updated successfully") {
//           toastSuccess("User updated successfully");
//           // router.reload();
//         }
//       });
//     };

//     const router = useNavigate();
//     // const route = useRouter();
//     console.warn(router.pathname);

//     return (
//       <>
//         <Box className={styles.commTabs}>
//           <Tabs
//             value={value}
//             onChange={handleChange}
//             aria-label="basic tabs example"
//           >
//             <Tab label="Personal Details" {...a11yProps(0)} />
//             <Tab label="Account Settings" {...a11yProps(1)} />
//           </Tabs>
//         </Box>

//         <Paper className={styles.accountPaper}>
//           <PerfectScrollbar className={styles.profileInnerScroll}>
//             <TabPanel value={value} index={0}>
//               <Box className={styles.accountFormGroup}>
//                 <Stack
//                   direction="row"
//                   alignItems="center"
//                   flexWrap="wrap"
//                   className={styles.labelStack}
//                 >
//                   <Typography variant="caption">Full name</Typography>

//                   {dis !== false ? (
//                     <Button onClick={handleopenD}>
//                       <EditBlueIcon />
//                     </Button>
//                   ) : (
//                     // <Button
//                     //   onClick={handleSubmit(onSubmit)}
//                     //   className={styles.btnUpdt}
//                     // >
//                     //   Update
//                     // </Button>
//                     <Box className={styles.editSaveBtn}>
//                       <Button onClick={handleopenDD}>
//                         <TabBackIcon />
//                       </Button>
//                       <Button onClick={handleSubmit(onSubmit)}>
//                         <TabSaveIcon />
//                       </Button>
//                     </Box>
//                   )}
//                 </Stack>
//                 <Box className={styles.gridWrap}>
//                   <Grid
//                     container
//                     rowSpacing={3}
//                     columnSpacing={{ xs: 1, sm: 2, md: 5.75 }}
//                   >
//                     <Grid item md={3.0815}>
//                       <Box className={styles.formGroup}>
//                         <label>First Name</label>
//                         <OutlinedInput
//                           {...register("name")}
//                           type="text"
//                           disabled={dis}
//                           placeholder="Name"
//                         />
//                         {errors.name && (
//                           <p
//                             style={{
//                               color: "red",
//                               textAlign: "left",
//                               fontSize: "15px",
//                             }}
//                           >
//                             {errors.name.message}
//                           </p>
//                         )}
//                       </Box>
//                     </Grid>
//                     <Grid item md={3.0815}>
//                       <Box className={styles.formGroup}>
//                         <label>last name</label>
//                         <OutlinedInput
//                           {...register("last_name")}
//                           disabled={dis}
//                           placeholder={"Name"}
//                         />
//                         {errors.last_name && (
//                           <p
//                             style={{
//                               color: "red",
//                               textAlign: "left",
//                               fontSize: "15px",
//                             }}
//                           >
//                             {errors.last_name.message}
//                           </p>
//                         )}
//                       </Box>
//                     </Grid>
//                   </Grid>
//                 </Box>
//               </Box>

//               <Box className={styles.accountFormGroup}>
//                 <Stack
//                   direction="row"
//                   alignItems="center"
//                   flexWrap="wrap"
//                   className={styles.labelStack}
//                 >
//                   <Typography variant="caption">Physical Address</Typography>
//                   {/* <Button>
//                       <Image
//                         src={assest.Iconedit}
//                         width={15}
//                         height={15}
//                         alt="icon"
//                       />
//                     </Button> */}
//                   {dis1 !== false ? (
//                     <Button onClick={handleopenD1}>
//                       <EditBlueIcon />
//                     </Button>
//                   ) : (
//                     // <Button
//                     //   onClick={handleSubmit(onSubmit)}
//                     //   className={styles.btnUpdt}
//                     // >
//                     //   Update
//                     // </Button>
//                     <Box className={styles.editSaveBtn}>
//                       <Button onClick={handleopenDD1}>
//                         <TabBackIcon />
//                       </Button>
//                       <Button onClick={handleSubmit(onSubmit)}>
//                         <TabSaveIcon />
//                       </Button>
//                     </Box>
//                   )}
//                 </Stack>
//                 <Box className={styles.gridWrap}>
//                   <Grid
//                     container
//                     rowSpacing={3.2}
//                     columnSpacing={{ xs: 1, sm: 2, md: 5.75 }}
//                   >
//                     <Grid item md={3.658}>
//                       <Box className={styles.formGroup}>
//                         <label>Address</label>
//                         <OutlinedInput
//                           {...register("address")}
//                           type="text"
//                           placeholder={""}
//                           disabled={dis1}
//                         />
//                       </Box>
//                     </Grid>
//                     <Grid item md={2.607}>
//                       <Box className={styles.formGroup}>
//                         <label>City</label>
//                         <OutlinedInput
//                           {...register("city")}
//                           type="text"
//                           placeholder={""}
//                           disabled={dis1}
//                         />
//                       </Box>
//                     </Grid>
//                     <Grid item md={2.607}>
//                       <Box className={styles.formGroup}>
//                         <label>State</label>
//                         <OutlinedInput
//                           {...register("state")}
//                           type="text"
//                           placeholder={""}
//                           disabled={dis1}
//                         />
//                       </Box>
//                     </Grid>
//                     <Grid item md={1.792}>
//                       <Box className={styles.formGroup}>
//                         <label>Zip Code</label>
//                         <OutlinedInput
//                           {...register("zip")}
//                           type="text"
//                           placeholder={""}
//                           disabled={dis1}
//                         />
//                       </Box>
//                     </Grid>

//                     <Controller
//                       name="country"
//                       control={control}
//                       render={({
//                         field: { onChange, value },
//                         fieldState: { invalid },
//                       }) => (
//                         <Grid item md={3.0815}>
//                           <Box className={styles.formGroup}>
//                             <label>Country</label>
//                             <Select
//                               disabled={dis1}
//                               value={Country}
//                               // onChange={handleChange2}
//                               onChange={(Country) => handleChange2(Country)}
//                               displayEmpty
//                               inputProps={{ "aria-label": "Without label" }}
//                             >
//                               {CopywritersUserdetails?.country !== "" ? (
//                                 <MenuItem value="">
//                                   {CopywritersUserdetails?.country}
//                                 </MenuItem>
//                               ) : (
//                                 <MenuItem value="">
//                                   Please Select Country
//                                 </MenuItem>
//                               )}

//                               {countryData.map((Data) => (
//                                 <MenuItem value={Data.name}>
//                                   {Data.name}({Data.code})
//                                 </MenuItem>
//                               ))}
//                             </Select>
//                           </Box>
//                         </Grid>
//                       )}
//                     />
//                   </Grid>
//                 </Box>
//               </Box>

//               <Box className={styles.accountFormGroup}>
//                 <Stack
//                   direction="row"
//                   alignItems="center"
//                   flexWrap="wrap"
//                   className={styles.labelStack}
//                 >
//                   <Typography variant="caption">Phone Number</Typography>
//                   {/* <Button>
//                       <Image
//                         src={assest.Iconedit}
//                         width={15}
//                         height={15}
//                         alt="icon"
//                       />
//                     </Button> */}
//                   {dis2 !== false ? (
//                     <Button onClick={handleopenD2}>
//                       <EditBlueIcon />
//                     </Button>
//                   ) : (
//                     // <Button
//                     //   onClick={handleSubmit(onSubmit)}
//                     //   className={styles.btnUpdt}
//                     // >
//                     //   Update
//                     // </Button>
//                     <Box className={styles.editSaveBtn}>
//                       <Button onClick={handleopenDD2}>
//                         <TabBackIcon />
//                       </Button>
//                       <Button onClick={handleSubmit(onSubmit)}>
//                         <TabSaveIcon />
//                       </Button>
//                     </Box>
//                   )}
//                 </Stack>
//                 <Box className={styles.gridWrap}>
//                   <Grid
//                     container
//                     rowSpacing={3}
//                     columnSpacing={{ xs: 1, sm: 2, md: 5.75 }}
//                   >
//                     <Grid item md={3.0815}>
//                       <Box className={styles.formGroup}>
//                         <OutlinedInput
//                           type="number"
//                           placeholder={""}
//                           disabled={dis2}
//                           {...register("phone")}
//                         />
//                         {errors.phone && (
//                           <p
//                             style={{
//                               color: "red",
//                               textAlign: "left",
//                               fontSize: "15px",
//                             }}
//                           >
//                             {errors.phone.message}
//                           </p>
//                         )}
//                       </Box>
//                     </Grid>
//                   </Grid>
//                 </Box>
//               </Box>
//             </TabPanel>

//             <TabPanel value={value} index={1}>
//               <Box
//                 className={`${styles.accountSettingWrapper} ${styles.accountSettingWrapperPartner}`}
//               >
//                 <Box
//                   className={`${styles.forProfilePic} ${styles1.forProfilePicPartner}`}
//                 >
//                   <Stack
//                     direction="row"
//                     alignItems="center"
//                     flexWrap="wrap"
//                     className={styles.labelStack}
//                   >
//                     <Typography variant="caption">Profile Picture</Typography>
//                   </Stack>
//                   <Stack
//                     direction="row"
//                     alignItems="center"
//                     flexWrap="wrap"
//                     className={styles.profileSec}
//                   >
//                     {/* {userData?.avatar !== null ? (
//                         <>
//                           <img
//                               src={URL.createObjectURL(profileImage)}
//                               width={380}
//                               height={220}
//                             />
//                             <Avatar
//                             alt="Profile Image"
//                             src={URL.createObjectURL(profileImage)}
//                             profileImage
//                             {userData?.avatar === null ? }
//                             src={`https://vsclips.s3.us-east-2.amazonaws.com/${profileImage}`}
//                             sx={{ width: 97, height: 97 }}
//                             />
//                         </>
//                       ) : (
//                         <>
//                           <Avatar
//                             alt="Profile Image"
//                             src={assest.noImg}
//                             sx={{ width: 97, height: 97 }}
//                           />
//                         </>
//                       )} */}

//                     {profileImage !== null ? (
//                       <>
//                         {/* <Image
//                             src={URL.createObjectURL(profileImage)}
//                             width={100}
//                             height={100}
//                             alt={""}
//                           /> */}

//                         <Avatar
//                           alt="Profile Image"
//                           src={URL.createObjectURL(profileImage)}
//                           sx={{ width: 97, height: 97 }}
//                         />
//                       </>
//                     ) : (
//                       <>
//                         <Avatar
//                           alt="Profile Image"
//                           src={`https://vsclips.s3.us-east-2.amazonaws.com/${CopywritersUserdetails?.avatar}`}
//                           sx={{ width: 97, height: 97 }}
//                         />
//                       </>
//                     )}

//                     <List>
//                       <ListItem className={styles.customUploadFile}>
//                         <input
//                           type="file"
//                           id="upload"
//                           hidden
//                           onChange={handleProfileImage1}
//                           accept="image/*"
//                         />
//                         {profileImage !== null ? (
//                           <>
//                             <label
//                               htmlFor="update"
//                               onClick={handleSubmit(onSubmit)}
//                             >
//                               update picture
//                             </label>
//                           </>
//                         ) : (
//                           <>
//                             <label htmlFor="upload">Upload picture</label>
//                           </>
//                         )}
//                       </ListItem>
//                       <ListItem>
//                         <Button
//                           className={styles.removeBtn}
//                           onClick={removeprofileImage}
//                         >
//                           remove it
//                         </Button>
//                       </ListItem>
//                     </List>
//                   </Stack>
//                 </Box>

//                 <Box className={styles.partnerAccountsSetting}>
//                   <Grid container spacing={2}>
//                     <Grid item xs={6}>
//                       <Box className={styles.partnerAccountLeft}>
//                         {/* {router.pathname == "/buyers-list" ||
//                           router.pathname == "/myaccount" ? (
//                           ""
//                         ) : (
//                           <Box className={styles.accountFormGroup}>
//                             <Stack
//                               direction="row"
//                               alignItems="center"
//                               flexWrap="wrap"
//                               className={styles.labelStack}
//                             >
//                               <Typography variant="caption">
//                                 Account Name
//                               </Typography>

//                               {dis !== false ? (
//                                 <Button onClick={handleopenD}>
//                                   <Image
//                                     src={assest.Iconedit}
//                                     width={15}
//                                     height={15}
//                                     alt="icon"
//                                   />
//                                 </Button>
//                               ) : (
//                                 <><Button
//                                       onClick={handleSubmit(onSubmit)}
//                                       className={styles.btnUpdt}
//                                     >
//                                       Update
//                                     </Button><Box className={styles.editSaveBtn}>
//                                         <Button>
//                                           <Image
//                                             src={assest.replaceIcon}
//                                             width={15}
//                                             height={15}
//                                             alt="icon" />
//                                         </Button>
//                                         <Button>
//                                           <Image
//                                             src={assest.saveIcon}
//                                             width={15}
//                                             height={15}
//                                             alt="icon" />
//                                         </Button>
//                                       </Box></>
//                               )}
//                             </Stack>

//                             <Box className={styles.formGroup}>
//                               <OutlinedInput
//                                 {...register("name")}
//                                 type="text"
//                                 disabled={dis}
//                                 placeholder="Name"
//                               />
//                               {errors.name && (
//                                 <p
//                                   style={{
//                                     color: "red",
//                                     textAlign: "left",
//                                     fontSize: "15px",
//                                   }}
//                                 >
//                                   {errors.name.message}
//                                 </p>
//                               )}
//                             </Box>
//                           </Box>
//                         )} */}

//                         <Box className={styles.forEmail}>
//                           <Stack
//                             direction="row"
//                             alignItems="center"
//                             flexWrap="wrap"
//                             className={styles.labelStack}
//                           >
//                             <Typography variant="caption">
//                               Email Address
//                             </Typography>
//                           </Stack>
//                           <Box className={styles.showEmail}>
//                             <Typography variant="body1">
//                               <strong>{CopywritersUserdetails?.email}</strong>
//                             </Typography>
//                             <Typography variant="caption">
//                               <img
//                                 src={assest.Iconcaution}
//                                 width={9}
//                                 height={8}
//                                 alt="icon"
//                               />
//                               Email address cannot be changed.
//                             </Typography>
//                           </Box>
//                         </Box>

//                         {/* {router.pathname == "/myaccount" ? (
//                           ""
//                         ) : (
//                           <Box className={styles.accountFormGroup}>
//                             <Box className={styles.accountSubmission}>
//                               <Stack
//                                 direction="row"
//                                 alignItems="center"
//                                 flexWrap="wrap"
//                                 className={styles.labelStack}
//                               >
//                                 <Typography variant="caption">
//                                   Fee per Submission
//                                 </Typography>

//                                 {dis !== false ? (
//                                   <Button onClick={handleopenD}>
//                                     <Image
//                                       src={assest.Iconedit}
//                                       width={15}
//                                       height={15}
//                                       alt="icon"
//                                     />
//                                   </Button>
//                                 ) : (
//                                   <><Button
//                                         onClick={handleSubmit(onSubmit)}
//                                         className={styles.btnUpdt}
//                                       >
//                                         Update
//                                       </Button><Box className={styles.editSaveBtn}>
//                                           <Button>
//                                             <Image
//                                               src={assest.replaceIcon}
//                                               width={15}
//                                               height={15}
//                                               alt="icon" />
//                                           </Button>
//                                           <Button>
//                                             <Image
//                                               src={assest.saveIcon}
//                                               width={15}
//                                               height={15}
//                                               alt="icon" />
//                                           </Button>
//                                         </Box></>
//                                 )}
//                               </Stack>

//                               <Button className={styles.accountSubmissionBtn}>
//                                 Change to Salary
//                               </Button>
//                             </Box>
//                             <Box className={styles.formGroup}>
//                               <Box className={styles.partnerFromGroupSub}>
//                                 <OutlinedInput
//                                   {...register("name")}
//                                   type="text"
//                                   disabled={dis}
//                                   placeholder="Name"
//                                 />
//                               </Box>
//                               {errors.name && (
//                                 <p
//                                   style={{
//                                     color: "red",
//                                     textAlign: "left",
//                                     fontSize: "15px",
//                                   }}
//                                 >
//                                   {errors.name.message}
//                                 </p>
//                               )}
//                             </Box>
//                           </Box>
//                         )} */}

//                         <Stack
//                           direction="row"
//                           alignItems="center"
//                           flexWrap="wrap"
//                           className={styles.forgotPassword}
//                         >
//                           <Typography variant="h3">
//                             Copywriter Forgot his Password?
//                           </Typography>
//                           <Link
//                             href="/password-recovery"
//                             className={styles.linedBtn}
//                           >
//                             {" "}
//                             Reset Password
//                           </Link>
//                           {/* <Button className={styles.linedBtn}>Reset Password</Button> */}
//                         </Stack>
//                       </Box>
//                     </Grid>
//                     {/* {props.accountSubmission && (
//                       <Grid item xs={6}>
//                         <Box className={styles.partnerAccountRight}>
//                           <Box className={styles.forEmail}>
//                             <Stack
//                               direction="row"
//                               alignItems="center"
//                               flexWrap="wrap"
//                               className={styles.labelStack}
//                             >
//                               <Typography variant="caption">
//                                 Submission Page
//                               </Typography>
//                             </Stack>
//                             <Box className={styles.showEmail}>
//                               <Typography variant="body1">
//                                 Your submission page URL is{" "}
//                                 <strong>{CopywritersUserdetails?.email}</strong>
//                               </Typography>
//                               <Typography variant="caption">
//                                 <Image
//                                   src={assest.Iconcaution}
//                                   width={9}
//                                   height={8}
//                                   alt="icon"
//                                 />
//                                 Submission page cannot be changed.
//                               </Typography>
//                             </Box>
//                           </Box>

//                           {router.pathname == "/buyers-list" ? (
//                             ""
//                           ) : (
//                             <Box className={styles.accountFormGroup}>
//                               <Box className={styles.accountSubmission}>
//                                 <Stack
//                                   direction="row"
//                                   alignItems="center"
//                                   flexWrap="wrap"
//                                   className={styles.labelStack}
//                                 >
//                                   <Typography variant="caption">
//                                     Revenue Share
//                                   </Typography>

//                                   {dis !== false ? (
//                                     <Button onClick={handleopenD}>
//                                       <Image
//                                         src={assest.Iconedit}
//                                         width={15}
//                                         height={15}
//                                         alt="icon"
//                                       />
//                                     </Button>
//                                   ) : (
//                                     // <Button
//                                     //   onClick={handleSubmit(onSubmit)}
//                                     //   className={styles.btnUpdt}
//                                     // >
//                                     //   Update
//                                     // </Button>
//                                     <Box className={styles.editSaveBtn}>
//                                       <Button>
//                                         <Image
//                                           src={assest.replaceIcon}
//                                           width={15}
//                                           height={15}
//                                           alt="icon"
//                                         />
//                                       </Button>
//                                       <Button>
//                                         <Image
//                                           src={assest.saveIcon}
//                                           width={15}
//                                           height={15}
//                                           alt="icon"
//                                         />
//                                       </Button>
//                                     </Box>
//                                   )}
//                                 </Stack>
//                               </Box>

//                               <Box className={styles.formGroup}>
//                                 <Box className={styles.partnerFromGroup}>
//                                   <OutlinedInput
//                                     {...register("name")}
//                                     type="text"
//                                     disabled={dis}
//                                     placeholder="Name"
//                                   />
//                                 </Box>
//                                 {errors.name && (
//                                   <p
//                                     style={{
//                                       color: "red",
//                                       textAlign: "left",
//                                       fontSize: "15px",
//                                     }}
//                                   >
//                                     {errors.name.message}
//                                   </p>
//                                 )}
//                               </Box>
//                             </Box>
//                           )}
//                         </Box>
//                       </Grid>
//                     )}
//                     {router.pathname == "/myaccount" ? (
//                       ""
//                     ) : (
//                       <Box className={styles.lastActive}>
//                         <p>Last Active: April 12, 2023 at 5:25:33 PM UTC</p>
//                       </Box>
//                     )} */}
//                   </Grid>
//                 </Box>
//                 <Box className={styles.lastActive}>
//                   <p>Last Active: April 12, 2023 at 5:25:33 PM UTC</p>
//                 </Box>
//               </Box>
//             </TabPanel>
//           </PerfectScrollbar>
//         </Paper>
//       </>
//     );
//   };

//   export default CopyWritesUserCreateTab;

import {
  Avatar,
  Box,
  Button,
  Grid,
  List,
  ListItem,
  MenuItem,
  OutlinedInput,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../../styles/pages/myaccount.module.scss";
import styles1 from "../../styles/components/partnerSubmissionFeeModal.module.scss";
import assest from "../../json/assest";
// import Image from "next/image";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { parseCookies } from "nookies";
// import validationText from "@/json/messages/validationText";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { ProfileUpdateMutation } from "../../api/functions/user.api";
// import { any, array } from "prop-types";
import { useAppSelector } from "../../hooks/useAppSelector";
// import { logout, setLoginData } from "../../reduxtoolkit/slices/userSlice";
import useNotiStack from "../../hooks/useNotistack";
import { phoneRegExp } from "../../config/regExp";
import { trimStartAndEnd } from "../../lib/functions/_helpers.lib";
// import { useRouter } from "next/router";
// import Link from "next/link";
import EditBlueIcon from "../../ui/Icons/EditBlueIcon";
import TabBackIcon from "../../ui/Icons/TabBackIcon";
import TabSaveIcon from "../../ui/Icons/TabSaveIcon";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
// import { EditorUserDeatilsutation } from "../../api/functions/editor.api";
import { CopyWUserDeatilsutation } from "../../api/functions/copywriters.api";
import { Link } from "react-router-dom";
import { EditorUserDeatilsutation } from "../../api/functions/editor.api";
import NOprofileImage from "../../public/assets/images/no-image.svg";
const countryData = [
  { name: "Afghanistan", code: "AF" },
  { name: "Åland Islands", code: "AX" },
  { name: "Albania", code: "AL" },
  { name: "Algeria", code: "DZ" },
  { name: "American Samoa", code: "AS" },
  { name: "AndorrA", code: "AD" },
  { name: "Angola", code: "AO" },
  { name: "Anguilla", code: "AI" },
  { name: "Antarctica", code: "AQ" },
  { name: "Antigua and Barbuda", code: "AG" },
  { name: "Argentina", code: "AR" },
  { name: "Armenia", code: "AM" },
  { name: "Aruba", code: "AW" },
  { name: "Australia", code: "AU" },
  { name: "Austria", code: "AT" },
  { name: "Azerbaijan", code: "AZ" },
  { name: "Bahamas", code: "BS" },
  { name: "Bahrain", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Barbados", code: "BB" },
  { name: "Belarus", code: "BY" },
  { name: "Belgium", code: "BE" },
  { name: "Belize", code: "BZ" },
  { name: "Benin", code: "BJ" },
  { name: "Bermuda", code: "BM" },
  { name: "Bhutan", code: "BT" },
  { name: "Bolivia", code: "BO" },
  { name: "Bosnia and Herzegovina", code: "BA" },
  { name: "Botswana", code: "BW" },
  { name: "Bouvet Island", code: "BV" },
  { name: "Brazil", code: "BR" },
  { name: "British Indian Ocean Territory", code: "IO" },
  { name: "Brunei Darussalam", code: "BN" },
  { name: "Bulgaria", code: "BG" },
  { name: "Burkina Faso", code: "BF" },
  { name: "Burundi", code: "BI" },
  { name: "Cambodia", code: "KH" },
  { name: "Cameroon", code: "CM" },
  { name: "Canada", code: "CA" },
  { name: "Cape Verde", code: "CV" },
  { name: "Cayman Islands", code: "KY" },
  { name: "Central African Republic", code: "CF" },
  { name: "Chad", code: "TD" },
  { name: "Chile", code: "CL" },
  { name: "China", code: "CN" },
  { name: "Christmas Island", code: "CX" },
  { name: "Cocos (Keeling) Islands", code: "CC" },
  { name: "Colombia", code: "CO" },
  { name: "Comoros", code: "KM" },
  { name: "Congo", code: "CG" },
  { name: "Congo, The Democratic Republic of the", code: "CD" },
  { name: "Cook Islands", code: "CK" },
  { name: "Costa Rica", code: "CR" },
  { name: "Cote D'Ivoire", code: "CI" },
  { name: "Croatia", code: "HR" },
  { name: "Cuba", code: "CU" },
  { name: "Cyprus", code: "CY" },
  { name: "Czech Republic", code: "CZ" },
  { name: "Denmark", code: "DK" },
  { name: "Djibouti", code: "DJ" },
  { name: "Dominica", code: "DM" },
  { name: "Dominican Republic", code: "DO" },
  { name: "Ecuador", code: "EC" },
  { name: "Egypt", code: "EG" },
  { name: "El Salvador", code: "SV" },
  { name: "Equatorial Guinea", code: "GQ" },
  { name: "Eritrea", code: "ER" },
  { name: "Estonia", code: "EE" },
  { name: "Ethiopia", code: "ET" },
  { name: "Falkland Islands (Malvinas)", code: "FK" },
  { name: "Faroe Islands", code: "FO" },
  { name: "Fiji", code: "FJ" },
  { name: "Finland", code: "FI" },
  { name: "France", code: "FR" },
  { name: "French Guiana", code: "GF" },
  { name: "French Polynesia", code: "PF" },
  { name: "French Southern Territories", code: "TF" },
  { name: "Gabon", code: "GA" },
  { name: "Gambia", code: "GM" },
  { name: "Georgia", code: "GE" },
  { name: "Germany", code: "DE" },
  { name: "Ghana", code: "GH" },
  { name: "Gibraltar", code: "GI" },
  { name: "Greece", code: "GR" },
  { name: "Greenland", code: "GL" },
  { name: "Grenada", code: "GD" },
  { name: "Guadeloupe", code: "GP" },
  { name: "Guam", code: "GU" },
  { name: "Guatemala", code: "GT" },
  { name: "Guernsey", code: "GG" },
  { name: "Guinea", code: "GN" },
  { name: "Guinea-Bissau", code: "GW" },
  { name: "Guyana", code: "GY" },
  { name: "Haiti", code: "HT" },
  { name: "Heard Island and Mcdonald Islands", code: "HM" },
  { name: "Holy See (Vatican City State)", code: "VA" },
  { name: "Honduras", code: "HN" },
  { name: "Hong Kong", code: "HK" },
  { name: "Hungary", code: "HU" },
  { name: "Iceland", code: "IS" },
  { name: "India", code: "IN" },
  { name: "Indonesia", code: "ID" },
  { name: "Iran, Islamic Republic Of", code: "IR" },
  { name: "Iraq", code: "IQ" },
  { name: "Ireland", code: "IE" },
  { name: "Isle of Man", code: "IM" },
  { name: "Israel", code: "IL" },
  { name: "Italy", code: "IT" },
  { name: "Jamaica", code: "JM" },
  { name: "Japan", code: "JP" },
  { name: "Jersey", code: "JE" },
  { name: "Jordan", code: "JO" },
  { name: "Kazakhstan", code: "KZ" },
  { name: "Kenya", code: "KE" },
  { name: "Kiribati", code: "KI" },
  { name: "Korea, Democratic People'S Republic of", code: "KP" },
  { name: "Korea, Republic of", code: "KR" },
  { name: "Kuwait", code: "KW" },
  { name: "Kyrgyzstan", code: "KG" },
  { name: "Lao People'S Democratic Republic", code: "LA" },
  { name: "Latvia", code: "LV" },
  { name: "Lebanon", code: "LB" },
  { name: "Lesotho", code: "LS" },
  { name: "Liberia", code: "LR" },
  { name: "Libyan Arab Jamahiriya", code: "LY" },
  { name: "Liechtenstein", code: "LI" },
  { name: "Lithuania", code: "LT" },
  { name: "Luxembourg", code: "LU" },
  { name: "Macao", code: "MO" },
  { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
  { name: "Madagascar", code: "MG" },
  { name: "Malawi", code: "MW" },
  { name: "Malaysia", code: "MY" },
  { name: "Maldives", code: "MV" },
  { name: "Mali", code: "ML" },
  { name: "Malta", code: "MT" },
  { name: "Marshall Islands", code: "MH" },
  { name: "Martinique", code: "MQ" },
  { name: "Mauritania", code: "MR" },
  { name: "Mauritius", code: "MU" },
  { name: "Mayotte", code: "YT" },
  { name: "Mexico", code: "MX" },
  { name: "Micronesia, Federated States of", code: "FM" },
  { name: "Moldova, Republic of", code: "MD" },
  { name: "Monaco", code: "MC" },
  { name: "Mongolia", code: "MN" },
  { name: "Montserrat", code: "MS" },
  { name: "Morocco", code: "MA" },
  { name: "Mozambique", code: "MZ" },
  { name: "Myanmar", code: "MM" },
  { name: "Namibia", code: "NA" },
  { name: "Nauru", code: "NR" },
  { name: "Nepal", code: "NP" },
  { name: "Netherlands", code: "NL" },
  { name: "Netherlands Antilles", code: "AN" },
  { name: "New Caledonia", code: "NC" },
  { name: "New Zealand", code: "NZ" },
  { name: "Nicaragua", code: "NI" },
  { name: "Niger", code: "NE" },
  { name: "Nigeria", code: "NG" },
  { name: "Niue", code: "NU" },
  { name: "Norfolk Island", code: "NF" },
  { name: "Northern Mariana Islands", code: "MP" },
  { name: "Norway", code: "NO" },
  { name: "Oman", code: "OM" },
  { name: "Pakistan", code: "PK" },
  { name: "Palau", code: "PW" },
  { name: "Palestinian Territory, Occupied", code: "PS" },
  { name: "Panama", code: "PA" },
  { name: "Papua New Guinea", code: "PG" },
  { name: "Paraguay", code: "PY" },
  { name: "Peru", code: "PE" },
  { name: "Philippines", code: "PH" },
  { name: "Pitcairn", code: "PN" },
  { name: "Poland", code: "PL" },
  { name: "Portugal", code: "PT" },
  { name: "Puerto Rico", code: "PR" },
  { name: "Qatar", code: "QA" },
  { name: "Reunion", code: "RE" },
  { name: "Romania", code: "RO" },
  { name: "Russian Federation", code: "RU" },
  { name: "RWANDA", code: "RW" },
  { name: "Saint Helena", code: "SH" },
  { name: "Saint Kitts and Nevis", code: "KN" },
  { name: "Saint Lucia", code: "LC" },
  { name: "Saint Pierre and Miquelon", code: "PM" },
  { name: "Saint Vincent and the Grenadines", code: "VC" },
  { name: "Samoa", code: "WS" },
  { name: "San Marino", code: "SM" },
  { name: "Sao Tome and Principe", code: "ST" },
  { name: "Saudi Arabia", code: "SA" },
  { name: "Senegal", code: "SN" },
  { name: "Serbia and Montenegro", code: "CS" },
  { name: "Seychelles", code: "SC" },
  { name: "Sierra Leone", code: "SL" },
  { name: "Singapore", code: "SG" },
  { name: "Slovakia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "Solomon Islands", code: "SB" },
  { name: "Somalia", code: "SO" },
  { name: "South Africa", code: "ZA" },
  { name: "South Georgia and the South Sandwich Islands", code: "GS" },
  { name: "Spain", code: "ES" },
  { name: "Sri Lanka", code: "LK" },
  { name: "Sudan", code: "SD" },
  { name: "Suriname", code: "SR" },
  { name: "Svalbard and Jan Mayen", code: "SJ" },
  { name: "Swaziland", code: "SZ" },
  { name: "Sweden", code: "SE" },
  { name: "Switzerland", code: "CH" },
  { name: "Syrian Arab Republic", code: "SY" },
  { name: "Taiwan, Province of China", code: "TW" },
  { name: "Tajikistan", code: "TJ" },
  { name: "Tanzania, United Republic of", code: "TZ" },
  { name: "Thailand", code: "TH" },
  { name: "Timor-Leste", code: "TL" },
  { name: "Togo", code: "TG" },
  { name: "Tokelau", code: "TK" },
  { name: "Tonga", code: "TO" },
  { name: "Trinidad and Tobago", code: "TT" },
  { name: "Tunisia", code: "TN" },
  { name: "Turkey", code: "TR" },
  { name: "Turkmenistan", code: "TM" },
  { name: "Turks and Caicos Islands", code: "TC" },
  { name: "Tuvalu", code: "TV" },
  { name: "Uganda", code: "UG" },
  { name: "Ukraine", code: "UA" },
  { name: "United Arab Emirates", code: "AE" },
  { name: "United Kingdom", code: "GB" },
  { name: "United States", code: "US" },
  { name: "United States Minor Outlying Islands", code: "UM" },
  { name: "Uruguay", code: "UY" },
  { name: "Uzbekistan", code: "UZ" },
  { name: "Vanuatu", code: "VU" },
  { name: "Venezuela", code: "VE" },
  { name: "Viet Nam", code: "VN" },
  { name: "Virgin Islands, British", code: "VG" },
  { name: "Virgin Islands, U.S.", code: "VI" },
  { name: "Wallis and Futuna", code: "WF" },
  { name: "Western Sahara", code: "EH" },
  { name: "Yemen", code: "YE" },
  { name: "Zambia", code: "ZM" },
  { name: "Zimbabwe", code: "ZW" },
];

// interface forgotProps {
//   // forgotText: 'myaccount' | 'editor' | 'copywriter' | 'for_partners';
//   forgotText:
//   | "myaccount"
//   | "editor"
//   | "copywriter"
//   | "for_partners"
//   | "for_QC"
//   | "for_manager";
//   accountSubmission: boolean;

//   userdata ;
// }

// interface TabPanelProps {
//   children?: React.ReactNode;
//   index: number;
//   value: number;
// }

//=== TYPES ====
// interface MyAccInput {
//   name: string;
//   last_name: string;
//   address: string;
//   city: string;
//   zip: string;
//   state: string;
//   phone: string;
//   avatar: string;
//   country: string;
// }

// schema

const schema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required()
    .label("First Name")
    .max(256)
    .transform(trimStartAndEnd),

  last_name: yup
    .string()
    .trim()
    .required()
    .label("Last Name")
    .max(256)
    .transform(trimStartAndEnd),

  address: yup.string().max(32),
  city: yup.string().max(32),

  zip: yup.string().max(7),

  phone: yup
    // .string()
    // .required()
    // .matches(phoneRegExp, "Phone number is not valid")
    // .label("Phone number"),
    .string()
    .required("Phone number is required")
    .min(8, "Phone number must be at least 8 characters")
    .max(15, "Phone number must be at most 15 characters"),

  state: yup.string().max(32),
});
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CopyWritesUserCreateTab = (props) => {
  console.warn("propsadsdsa", props?.userdata);

  const cookies = parseCookies();
  // const userdeatails = JSON?.parse(cookies?.userdetails || "{}");

  const { userData } = useAppSelector((s) => s.userSlice);
  const { data: CopywritersUserdetails } = useQuery(
    ["userdeatils", props?.userdata.id],
    async () => {
      return CopyWUserDeatilsutation(props?.userdata.id);
    }
  );

  const [value, setValue] = React.useState(0);
  const [age, setAge] = React.useState("");
  const [dis, setDis] = useState(true);
  const [dis1, setDis1] = useState(true);
  const [dis2, setDis2] = useState(true);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const {
    handleSubmit,
    control,
    register,

    reset,
    formState: { errors },
    formState,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: props?.userdata?.name,
      last_name: props?.userdata?.last_name,
      address: props?.userdata?.address,
      city: props?.userdata?.city,
      zip: props?.userdata?.zip_code,
      state: props?.userdata?.state,
      phone: props?.userdata?.phone,
      avatar: props?.userdata?.avatar,
      country: props?.userdata?.country,
    },
  });
  // const onSubmit = (data: MyAccInput) => console.warn(data);
  const [Country, setCountry] = useState(props?.userdata?.country);

  const handleChange2 = (event) => {
    setCountry(event.target.value);
  };
  const handleopenD = () => {
    setDis(false);
  };
  const handleopenD1 = () => {
    setDis1(false);
  };
  const handleopenD2 = () => {
    setDis2(false);
  };

  const handleopenDD = () => {
    setDis(true);
  };
  const handleopenDD1 = () => {
    setDis1(true);
  };
  const handleopenDD2 = () => {
    setDis2(true);
  };

  const { mutateAsync: ProfileUpdateMutationAA } = useMutation({
    mutationFn: ProfileUpdateMutation,
  });
  const { toastSuccess, toastError } = useNotiStack();
  const queryClient = useQueryClient();
  7;
  const [profileImage, setProfileImage] = useState(null);
  const [profileimg, setprofileimg] = useState(props?.userdata?.avatar);
  const [inputKey, setInputKey] = useState(0);

  const removeprofileImage = () => {
    setProfileImage(null);
    setprofileimg(null);
    setInputKey((prevKey) => prevKey + 1);
    const formData = new FormData();

    formData.append("remove_avatar", true);
    formData.append("user_id", props?.userdata?.id);
    ProfileUpdateMutationAA(formData).then((response) => {
      // console.warn(response)
      if (response.message === "User updated successfully") {
        queryClient.invalidateQueries(["copywritersData"]);
        setDis(true);
        setDis1(true);
        setDis2(true);
        toastSuccess("User updated successfully");

        // router.reload();
      }
    });
  };

  function handleProfileImage1(e) {
    if (
      e.target.files[0]?.type === "image/jpeg" ||
      e.target.files[0]?.type === "image/png" ||
      e.target.files[0]?.type === "image/jpg"
    ) {
      if (e.target.files[0]?.size <= 10000000) {
        setProfileImage(e.target.files[0]);
      } else {
        toastError("Please upload image of proper size.");
      }
    } else {
      toastError("Please upload image of proper format.");
    }
  }

  const onSubmit = (data) => {
    const formData = new FormData();
    {
      profileImage === null ? "" : formData.append("avatar", profileImage);
    }
    formData.append("name", data?.name);
    formData.append("last_name", data?.last_name);
    formData.append("user_id", props?.userdata?.id);
    formData.append("email", props?.userdata?.email);
    formData.append("address", data?.address || "");
    formData.append("city", data?.city || "");
    formData.append("zip_code", data?.zip || "");
    formData.append("phone", data?.phone);
    formData.append("state", data?.state || "");
    formData.append("country", Country);

    ProfileUpdateMutationAA(formData).then((response) => {
      // console.warn(response)
      if (response.message === "User updated successfully") {
        queryClient.invalidateQueries(["copywritersData"]);
        setDis(true);
        setDis1(true);
        setDis2(true);
        toastSuccess("User updated successfully");

        // router.reload();
      }
    });
  };

  // const router = useRouter();
  // console.warn(router.pathname);

  return (
    <>
      <Box className={styles.commTabs}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Personal Details" {...a11yProps(0)} />
          <Tab label="Account Settings" {...a11yProps(1)} />
        </Tabs>
      </Box>

      <Paper className={styles.accountPaper}>
        <PerfectScrollbar className={styles.profileInnerScroll}>
          <TabPanel value={value} index={0}>
            <Box className={styles.accountFormGroup}>
              <Stack
                direction="row"
                alignItems="center"
                flexWrap="wrap"
                className={styles.labelStack}
              >
                <Typography variant="caption">Full name</Typography>

                {dis !== false ? (
                  <Button onClick={handleopenD}>
                    <EditBlueIcon />
                  </Button>
                ) : (
                  // <Button
                  //   onClick={handleSubmit(onSubmit)}
                  //   className={styles.btnUpdt}
                  // >
                  //   Update
                  // </Button>
                  <Box className={styles.editSaveBtn}>
                    <Button onClick={handleopenDD}>
                      <TabBackIcon />
                    </Button>
                    <Button onClick={handleSubmit(onSubmit)}>
                      <TabSaveIcon />
                    </Button>
                  </Box>
                )}
              </Stack>
              <Box className={styles.gridWrap}>
                <Grid
                  container
                  rowSpacing={3}
                  columnSpacing={{ xs: 1, sm: 2, md: 5.75 }}
                >
                  <Grid item md={3.0815}>
                    <Box className={styles.formGroup}>
                      <label>First Name</label>
                      <OutlinedInput
                        {...register("name")}
                        type="text"
                        disabled={dis}
                        placeholder="Name"
                      />
                      {errors.name && (
                        <p
                          style={{
                            color: "red",
                            textAlign: "left",
                            fontSize: "15px",
                          }}
                        >
                          {errors.name.message}
                        </p>
                      )}
                    </Box>
                  </Grid>
                  <Grid item md={3.0815}>
                    <Box className={styles.formGroup}>
                      <label>last name</label>
                      <OutlinedInput
                        {...register("last_name")}
                        disabled={dis}
                        placeholder={"Name"}
                      />
                      {errors.last_name && (
                        <p
                          style={{
                            color: "red",
                            textAlign: "left",
                            fontSize: "15px",
                          }}
                        >
                          {errors.last_name.message}
                        </p>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>

            <Box className={styles.accountFormGroup}>
              <Stack
                direction="row"
                alignItems="center"
                flexWrap="wrap"
                className={styles.labelStack}
              >
                <Typography variant="caption">Physical Address</Typography>
                {/* <Button>
                    <img
                      src={assest.Iconedit}
                      width={15}
                      height={15}
                      alt="icon"
                    />
                  </Button> */}
                {dis1 !== false ? (
                  <Button onClick={handleopenD1}>
                    <EditBlueIcon />
                  </Button>
                ) : (
                  // <Button
                  //   onClick={handleSubmit(onSubmit)}
                  //   className={styles.btnUpdt}
                  // >
                  //   Update
                  // </Button>
                  <Box className={styles.editSaveBtn}>
                    <Button onClick={handleopenDD1}>
                      <TabBackIcon />
                    </Button>
                    <Button onClick={handleSubmit(onSubmit)}>
                      <TabSaveIcon />
                    </Button>
                  </Box>
                )}
              </Stack>
              <Box className={styles.gridWrap}>
                <Grid
                  container
                  rowSpacing={3.2}
                  columnSpacing={{ xs: 1, sm: 2, md: 5.75 }}
                >
                  <Grid item md={3.658}>
                    <Box className={styles.formGroup}>
                      <label>Address</label>
                      <OutlinedInput
                        {...register("address")}
                        type="text"
                        placeholder={""}
                        disabled={dis1}
                      />
                    </Box>
                  </Grid>
                  <Grid item md={2.607}>
                    <Box className={styles.formGroup}>
                      <label>City</label>
                      <OutlinedInput
                        {...register("city")}
                        type="text"
                        placeholder={""}
                        disabled={dis1}
                      />
                    </Box>
                  </Grid>
                  <Grid item md={2.607}>
                    <Box className={styles.formGroup}>
                      <label>State</label>
                      <OutlinedInput
                        {...register("state")}
                        type="text"
                        placeholder={""}
                        disabled={dis1}
                      />
                    </Box>
                  </Grid>
                  <Grid item md={1.792}>
                    <Box className={styles.formGroup}>
                      <label>Zip Code</label>
                      <OutlinedInput
                        {...register("zip")}
                        type="text"
                        placeholder={""}
                        disabled={dis1}
                      />
                    </Box>
                  </Grid>

                  <Controller
                    name="country"
                    control={control}
                    render={({
                      field: { onChange, value },
                      fieldState: { invalid },
                    }) => (
                      <Grid item md={3.0815}>
                        <Box className={styles.formGroup}>
                          <label>Country</label>
                          <Select
                            disabled={dis1}
                            value={Country}
                            // onChange={handleChange2}
                            onChange={(Country) => handleChange2(Country)}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            {CopywritersUserdetails?.country !== "" ? (
                              <MenuItem value="">
                                {CopywritersUserdetails?.country}
                              </MenuItem>
                            ) : (
                              <MenuItem value="">
                                Please Select Country
                              </MenuItem>
                            )}

                            {countryData.map((Data) => (
                              <MenuItem value={Data.name}>
                                {Data.name}({Data.code})
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>
                      </Grid>
                    )}
                  />
                </Grid>
              </Box>
            </Box>

            <Box className={styles.accountFormGroup}>
              <Stack
                direction="row"
                alignItems="center"
                flexWrap="wrap"
                className={styles.labelStack}
              >
                <Typography variant="caption">Phone Number</Typography>
                {/* <Button>
                    <img
                      src={assest.Iconedit}
                      width={15}
                      height={15}
                      alt="icon"
                    />
                  </Button> */}
                {dis2 !== false ? (
                  <Button onClick={handleopenD2}>
                    <EditBlueIcon />
                  </Button>
                ) : (
                  // <Button
                  //   onClick={handleSubmit(onSubmit)}
                  //   className={styles.btnUpdt}
                  // >
                  //   Update
                  // </Button>
                  <Box className={styles.editSaveBtn}>
                    <Button onClick={handleopenDD2}>
                      <TabBackIcon />
                    </Button>
                    <Button onClick={handleSubmit(onSubmit)}>
                      <TabSaveIcon />
                    </Button>
                  </Box>
                )}
              </Stack>
              <Box className={styles.gridWrap}>
                <Grid
                  container
                  rowSpacing={3}
                  columnSpacing={{ xs: 1, sm: 2, md: 5.75 }}
                >
                  <Grid item md={3.0815}>
                    <Box className={styles.formGroup}>
                      <OutlinedInput
                        type="number"
                        placeholder={""}
                        disabled={dis2}
                        {...register("phone")}
                      />
                      {errors.phone && (
                        <p
                          style={{
                            color: "red",
                            textAlign: "left",
                            fontSize: "15px",
                          }}
                        >
                          {errors.phone.message}
                        </p>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </TabPanel>

          <TabPanel value={value} index={1}>
            <Box
              className={`${styles.accountSettingWrapper} ${styles.accountSettingWrapperPartner}`}
            >
              <Box
                className={`${styles.forProfilePic} ${styles1.forProfilePicPartner}`}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  flexWrap="wrap"
                  className={styles.labelStack}
                >
                  <Typography variant="caption">Profile Picture</Typography>
                </Stack>
                <Stack
                  direction="row"
                  alignItems="center"
                  flexWrap="wrap"
                  className={styles.profileSec}
                >
                  {/* {userData?.avatar !== null ? (
                      <>
                        <img
                            src={URL.createObjectURL(profileImage)}
                            width={380}
                            height={220}
                          />
                          <Avatar
                          alt="Profile Image"
                          src={URL.createObjectURL(profileImage)}
                          profileImage
                          {userData?.avatar === null ? }
                          src={`https://vsclips.s3.us-east-2.amazonaws.com/${profileImage}`}
                          sx={{ width: 97, height: 97 }}
                          />
                      </>
                    ) : (
                      <>
                        <Avatar
                          alt="Profile Image"
                          src={assest.noImg}
                          sx={{ width: 97, height: 97 }}
                        />
                      </>
                    )} */}

                  {/* {profileImage !== null ? (
                    <>
                 

                      <Avatar
                        alt="Profile Image"
                        src={URL.createObjectURL(profileImage)}
                        sx={{ width: 97, height: 97 }}
                      />
                    </>
                  ) : (
                    <>
                      <Avatar
                        alt="Profile Image"
                        // src={`https://vsclips.s3.us-east-2.amazonaws.com/${profileimg}`}
                        src={  profileimg   === "users/default.png" ? NOprofileImage :`https://vsclips.s3.us-east-2.amazonaws.com/${profileimg}`}  
                        sx={{ width: 97, height: 97 }}
                      />
                    </>
                  )} */}

                  {profileImage !== null ? (
                    <>
                      {/* <img
                          src={URL.createObjectURL(profileImage)}
                          width={100}
                          height={100}
                          alt={""}
                        /> */}

                      <Avatar
                        alt="Profile Image"
                        src={URL.createObjectURL(profileImage)}
                        sx={{ width: 97, height: 97 }}
                      />
                    </>
                  ) : (
                    <>
                      {profileimg === null ? (
                        <Avatar
                          alt="Profile Image"
                          src={NOprofileImage}
                          sx={{ width: 97, height: 97 }}
                        />
                      ) : (
                        <>
                          {props?.userdata?.avatar === "users/default.png" ? (
                            <Avatar
                              alt="Profile Image"
                              src={NOprofileImage}
                              sx={{ width: 97, height: 97 }}
                            />
                          ) : (
                            <Avatar
                              alt="Profile Image"
                              src={concatHostAndImagePath(
                                props?.userdata?.avatar
                              )}
                              sx={{ width: 97, height: 97 }}
                            />
                          )}
                        </>
                      )}
                    </>
                  )}
                  <List>
                    <ListItem className={styles.customUploadFile}>
                      <input
                        key={inputKey}
                        type="file"
                        id="upload"
                        hidden
                        onChange={handleProfileImage1}
                        accept="image/*"
                      />
                      {profileImage !== null ? (
                        <>
                          <label
                            htmlFor="update"
                            onClick={handleSubmit(onSubmit)}
                          >
                            update picture
                          </label>
                        </>
                      ) : (
                        <>
                          <label htmlFor="upload">Upload picture</label>
                        </>
                      )}
                    </ListItem>
                    <ListItem>
                      <Button
                        className={styles.removeBtn}
                        onClick={removeprofileImage}
                      >
                        remove it
                      </Button>
                    </ListItem>
                  </List>
                </Stack>
              </Box>

              <Box className={styles.partnerAccountsSetting}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Box className={styles.partnerAccountLeft}>
                      {/* {router.pathname == "/buyers-list" ||
                        router.pathname == "/myaccount" ? (
                        ""
                      ) : (
                        <Box className={styles.accountFormGroup}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            flexWrap="wrap"
                            className={styles.labelStack}
                          >
                            <Typography variant="caption">
                              Account Name
                            </Typography>

                            {dis !== false ? (
                              <Button onClick={handleopenD}>
                                <img
                                  src={assest.Iconedit}
                                  width={15}
                                  height={15}
                                  alt="icon"
                                />
                              </Button>
                            ) : (
                              <><Button
                                    onClick={handleSubmit(onSubmit)}
                                    className={styles.btnUpdt}
                                  >
                                    Update
                                  </Button><Box className={styles.editSaveBtn}>
                                      <Button>
                                        <img
                                          src={assest.replaceIcon}
                                          width={15}
                                          height={15}
                                          alt="icon" />
                                      </Button>
                                      <Button>
                                        <img
                                          src={assest.saveIcon}
                                          width={15}
                                          height={15}
                                          alt="icon" />
                                      </Button>
                                    </Box></>
                            )}
                          </Stack>

                          <Box className={styles.formGroup}>
                            <OutlinedInput
                              {...register("name")}
                              type="text"
                              disabled={dis}
                              placeholder="Name"
                            />
                            {errors.name && (
                              <p
                                style={{
                                  color: "red",
                                  textAlign: "left",
                                  fontSize: "15px",
                                }}
                              >
                                {errors.name.message}
                              </p>
                            )}
                          </Box>
                        </Box>
                      )} */}

                      <Box className={styles.forEmail}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          flexWrap="wrap"
                          className={styles.labelStack}
                        >
                          <Typography variant="caption">
                            Email Address
                          </Typography>
                        </Stack>
                        <Box className={styles.showEmail}>
                          <Typography variant="body1">
                            {/* <strong>{CopywritersUserdetails?.email}</strong> */}
                            <strong>{props?.userdata?.email}</strong>
                          </Typography>
                          <Typography variant="caption">
                            <img
                              src={assest.Iconcaution}
                              width={9}
                              height={8}
                              alt="icon"
                            />
                            Email address cannot be changed.
                          </Typography>
                        </Box>
                      </Box>

                      {/* {router.pathname == "/myaccount" ? (
                        ""
                      ) : (
                        <Box className={styles.accountFormGroup}>
                          <Box className={styles.accountSubmission}>
                            <Stack
                              direction="row"
                              alignItems="center"
                              flexWrap="wrap"
                              className={styles.labelStack}
                            >
                              <Typography variant="caption">
                                Fee per Submission
                              </Typography>

                              {dis !== false ? (
                                <Button onClick={handleopenD}>
                                  <img
                                    src={assest.Iconedit}
                                    width={15}
                                    height={15}
                                    alt="icon"
                                  />
                                </Button>
                              ) : (
                                <><Button
                                      onClick={handleSubmit(onSubmit)}
                                      className={styles.btnUpdt}
                                    >
                                      Update
                                    </Button><Box className={styles.editSaveBtn}>
                                        <Button>
                                          <img
                                            src={assest.replaceIcon}
                                            width={15}
                                            height={15}
                                            alt="icon" />
                                        </Button>
                                        <Button>
                                          <img
                                            src={assest.saveIcon}
                                            width={15}
                                            height={15}
                                            alt="icon" />
                                        </Button>
                                      </Box></>
                              )}
                            </Stack>

                            <Button className={styles.accountSubmissionBtn}>
                              Change to Salary
                            </Button>
                          </Box>
                          <Box className={styles.formGroup}>
                            <Box className={styles.partnerFromGroupSub}>
                              <OutlinedInput
                                {...register("name")}
                                type="text"
                                disabled={dis}
                                placeholder="Name"
                              />
                            </Box>
                            {errors.name && (
                              <p
                                style={{
                                  color: "red",
                                  textAlign: "left",
                                  fontSize: "15px",
                                }}
                              >
                                {errors.name.message}
                              </p>
                            )}
                          </Box>
                        </Box>
                      )} */}

                      <Stack
                        direction="row"
                        alignItems="center"
                        flexWrap="wrap"
                        className={styles.forgotPassword}
                      >
                        <Typography variant="h3">
                          QC Agent Forgot his Password?
                        </Typography>
                        <a
                          href="/password-recovery"
                          className={styles.linedBtn}
                        >
                          {" "}
                          Reset Password
                        </a>
                        {/* <Button className={styles.linedBtn}>Reset Password</Button> */}
                      </Stack>
                    </Box>
                  </Grid>
                  {/* {props.accountSubmission && (
                    <Grid item xs={6}>
                      <Box className={styles.partnerAccountRight}>
                        <Box className={styles.forEmail}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            flexWrap="wrap"
                            className={styles.labelStack}
                          >
                            <Typography variant="caption">
                              Submission Page
                            </Typography>
                          </Stack>
                          <Box className={styles.showEmail}>
                            <Typography variant="body1">
                              Your submission page URL is{" "}
                              <strong>{CopywritersUserdetails?.email}</strong>
                            </Typography>
                            <Typography variant="caption">
                              <img
                                src={assest.Iconcaution}
                                width={9}
                                height={8}
                                alt="icon"
                              />
                              Submission page cannot be changed.
                            </Typography>
                          </Box>
                        </Box>

                        {router.pathname == "/buyers-list" ? (
                          ""
                        ) : (
                          <Box className={styles.accountFormGroup}>
                            <Box className={styles.accountSubmission}>
                              <Stack
                                direction="row"
                                alignItems="center"
                                flexWrap="wrap"
                                className={styles.labelStack}
                              >
                                <Typography variant="caption">
                                  Revenue Share
                                </Typography>

                                {dis !== false ? (
                                  <Button onClick={handleopenD}>
                                    <img
                                      src={assest.Iconedit}
                                      width={15}
                                      height={15}
                                      alt="icon"
                                    />
                                  </Button>
                                ) : (
                                  // <Button
                                  //   onClick={handleSubmit(onSubmit)}
                                  //   className={styles.btnUpdt}
                                  // >
                                  //   Update
                                  // </Button>
                                  <Box className={styles.editSaveBtn}>
                                    <Button>
                                      <img
                                        src={assest.replaceIcon}
                                        width={15}
                                        height={15}
                                        alt="icon"
                                      />
                                    </Button>
                                    <Button>
                                      <img
                                        src={assest.saveIcon}
                                        width={15}
                                        height={15}
                                        alt="icon"
                                      />
                                    </Button>
                                  </Box>
                                )}
                              </Stack>
                            </Box>

                            <Box className={styles.formGroup}>
                              <Box className={styles.partnerFromGroup}>
                                <OutlinedInput
                                  {...register("name")}
                                  type="text"
                                  disabled={dis}
                                  placeholder="Name"
                                />
                              </Box>
                              {errors.name && (
                                <p
                                  style={{
                                    color: "red",
                                    textAlign: "left",
                                    fontSize: "15px",
                                  }}
                                >
                                  {errors.name.message}
                                </p>
                              )}
                            </Box>
                          </Box>
                        )}
                      </Box>
                    </Grid>
                  )}
                  {router.pathname == "/myaccount" ? (
                    ""
                  ) : (
                    <Box className={styles.lastActive}>
                      <p>Last Active: April 12, 2023 at 5:25:33 PM UTC</p>
                    </Box>
                  )} */}
                </Grid>
              </Box>
            </Box>
          </TabPanel>
        </PerfectScrollbar>
      </Paper>
    </>
  );
};

export default CopyWritesUserCreateTab;
